const style = {
  helpText: {
    position: "relative",
    bottom: 9,
    fontSize: 13,
    color: "rgba(0, 0, 0, 0.4)",
    transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms"
  },
  successText: {
    position: "relative",
    bottom: 9,
    fontSize: 13,
    color: "#4CAF50",
    transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms"
  }
};

export default style;



// WEBPACK FOOTER //
// ./src/components/Field/style.js